import { AlignTypes } from '@monorepo-web/components-library';
import { helperFormat, FormatTypes, auxFormatPercent } from '@monorepo-web/utils';
export function formatDatesApi(graficoRetornos) {
    const datesApi = graficoRetornos
        ? graficoRetornos.slice(1).map((item) => item[0])
        : null;
    return datesApi;
}
export function formatDates(datesApi) {
    const SiglaMes = [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
    ];
    const datesAnoMes = datesApi === null || datesApi === void 0 ? void 0 : datesApi.map((item) => item.substring(2, 7));
    datesAnoMes === null || datesAnoMes === void 0 ? void 0 : datesAnoMes.reverse();
    const dates = [];
    datesAnoMes === null || datesAnoMes === void 0 ? void 0 : datesAnoMes.forEach(function (item, i) {
        dates[i] = `${SiglaMes[Number(item.substring(3, 5)) - 1]}/${item.substring(0, 2)}`;
    });
    dates.reverse();
    return dates;
}
export function formatData(assetsApi, dados, dates, datesTooltip) {
    const data = [];
    dates.forEach((item, i) => data.push({ name: item, datesTooltip: datesTooltip[i] }));
    assetsApi === null || assetsApi === void 0 ? void 0 : assetsApi.forEach(function (itemAsset, indexAsset) {
        data.forEach(function (itemData, i) {
            itemData[itemAsset] = dados[i][indexAsset + 1];
        });
    });
    return data;
}
export function formatDataEvol(assetsApi, dadosEvol, dates, datesTooltip) {
    const dataEvol = [];
    dates.forEach((item, i) => dataEvol.push({ name: item, datesTooltip: datesTooltip[i] }));
    assetsApi === null || assetsApi === void 0 ? void 0 : assetsApi.forEach(function (itemAsset) {
        if (itemAsset === 'Carteira_retorno') {
            dataEvol.forEach(function (itemData, i) {
                itemData[assetsApi[0]] = dadosEvol[i][1];
            });
        }
    });
    return dataEvol;
}
export function formatDadosMesaMesAgrupados(dadosMesaMes) {
    const dadosMesaMesAgrupados = dadosMesaMes === null || dadosMesaMes === void 0 ? void 0 : dadosMesaMes.reduce((accum, current) => {
        const year = current[0];
        if (!year || year === '')
            return accum;
        const values = current.slice(1);
        if (!accum[year])
            accum[year] = [];
        accum[year].push(values);
        return accum;
    }, {});
    return dadosMesaMesAgrupados;
}
export function getColumnsRetornos(dadosMesaMesAgrupados, theme) {
    const columnsRetornos = [
        {
            id: 'ano',
            label: '',
            rowSpan: Object.keys(dadosMesaMesAgrupados).length <= 0
                ? 0
                : dadosMesaMesAgrupados[Object.keys(dadosMesaMesAgrupados)[0]].length,
            bgColor: theme.sideBoxColor,
            color: 'white',
            padding: '4px',
            align: AlignTypes.center,
            borderLeftRadius: '5px',
            freeze: true,
        },
        {
            id: 'ativo',
            label: 'Ativo',
            freeze: true,
            leftOnFreeze: 40,
            noBreak: true,
        },
        { id: 'Jan', label: 'Jan', align: AlignTypes.right },
        { id: 'Fev', label: 'Fev', align: AlignTypes.right },
        { id: 'Mar', label: 'Mar', align: AlignTypes.right },
        { id: 'Abr', label: 'Abr', align: AlignTypes.right },
        { id: 'Mai', label: 'Mai', align: AlignTypes.right },
        { id: 'Jun', label: 'Jun', align: AlignTypes.right },
        { id: 'Jul', label: 'Jul', align: AlignTypes.right },
        { id: 'Ago', label: 'Ago', align: AlignTypes.right },
        { id: 'Set', label: 'Set', align: AlignTypes.right },
        { id: 'Out', label: 'Out', align: AlignTypes.right },
        { id: 'Nov', label: 'Nov', align: AlignTypes.right },
        { id: 'Dez', label: 'Dez', align: AlignTypes.right },
        { id: 'Ano', label: 'Ano', align: AlignTypes.right },
        { id: 'Acum', label: 'Acum', align: AlignTypes.right },
    ];
    return columnsRetornos;
}
export function formatRowsRetornos(dadosMesaMesAgrupados, invertDadosMesaMesAgrupados) {
    const rowsRetornos = dadosMesaMesAgrupados
        ? invertDadosMesaMesAgrupados(dadosMesaMesAgrupados).flatMap(([year, data]) => data.map((subArray, index) => {
            let i = 0;
            const rowData = {
                ativo: subArray[i++],
                Jan: helperFormat(auxFormatPercent(subArray[i++]), FormatTypes.decimals, 2),
                Fev: helperFormat(auxFormatPercent(subArray[i++]), FormatTypes.decimals, 2),
                Mar: helperFormat(auxFormatPercent(subArray[i++]), FormatTypes.decimals, 2),
                Abr: helperFormat(auxFormatPercent(subArray[i++]), FormatTypes.decimals, 2),
                Mai: helperFormat(auxFormatPercent(subArray[i++]), FormatTypes.decimals, 2),
                Jun: helperFormat(auxFormatPercent(subArray[i++]), FormatTypes.decimals, 2),
                Jul: helperFormat(auxFormatPercent(subArray[i++]), FormatTypes.decimals, 2),
                Ago: helperFormat(auxFormatPercent(subArray[i++]), FormatTypes.decimals, 2),
                Set: helperFormat(auxFormatPercent(subArray[i++]), FormatTypes.decimals, 2),
                Out: helperFormat(auxFormatPercent(subArray[i++]), FormatTypes.decimals, 2),
                Nov: helperFormat(auxFormatPercent(subArray[i++]), FormatTypes.decimals, 2),
                Dez: helperFormat(auxFormatPercent(subArray[i++]), FormatTypes.decimals, 2),
                Ano: helperFormat(auxFormatPercent(subArray[i++]), FormatTypes.decimals, 2),
                Acum: helperFormat(auxFormatPercent(subArray[i++]), FormatTypes.decimals, 2),
            };
            if (index === 0)
                rowData.ano = year;
            return rowData;
        }))
        : null;
    return rowsRetornos;
}
export function getColumnsAplRes() {
    const columnsAplRes = [
        { id: 'mesano', label: 'Mês/Ano', freeze: true },
        { id: 'saldoIni', label: 'Saldo Inicial (A)', align: AlignTypes.right },
        { id: 'aplicacoes', label: 'Aplicações (B)', align: AlignTypes.right },
        { id: 'resgates', label: 'Resgates (C)', align: AlignTypes.right },
        { id: 'impostos', label: 'Impostos Pagos (D)', align: AlignTypes.right },
        { id: 'saldoMovim', label: 'Saldo Movimentações (E=B-C)', align: AlignTypes.right },
        { id: 'rendNominal', label: 'Rendimento Nominal (F)', align: AlignTypes.right },
        { id: 'saldoFim', label: 'Saldo Final (G=A-D+E+F)', align: AlignTypes.right },
    ];
    return columnsAplRes;
}
export function formatRowsAplRes(movimentacoes) {
    const rowsAplRes = movimentacoes
        ? movimentacoes.map((movim) => {
            return {
                mesano: movim.data,
                saldoIni: helperFormat(movim.saldoBrutoIni, FormatTypes.decimals),
                aplicacoes: helperFormat(movim.apl, FormatTypes.decimals),
                resgates: helperFormat(movim.res, FormatTypes.decimals),
                impostos: helperFormat(movim.imp, FormatTypes.decimals),
                saldoMovim: helperFormat(movim.saldoMovim, FormatTypes.decimals),
                rendNominal: helperFormat(movim.rend, FormatTypes.decimals),
                saldoFim: helperFormat(movim.saldoBruto, FormatTypes.decimals),
            };
        })
        : null;
    return rowsAplRes;
}
export function getColsTabelaRendClasseMes(isPercentToggle, periodoModal) {
    const colsTabelaPorClasse = [
        {
            id: 'ativo',
            label: 'Ativo',
            width: '300px',
        },
        {
            id: 'rend',
            label: `${isPercentToggle ? 'Performance' : 'Rendimento'} em ${periodoModal}`,
            align: AlignTypes.right,
        },
    ];
    return colsTabelaPorClasse;
}
export function formatRowsTabelaRendClasseMes(classPeriodData, moneyPrefix, theme) {
    const rowsTabelaPorClasse = [];
    classPeriodData.data.forEach((obj) => {
        rowsTabelaPorClasse.push({
            ativo: obj.subclasse,
            rend: helperFormat(obj.rend, FormatTypes.monetary, 2, moneyPrefix),
            bgColor: '#E7E7E7',
            color: theme.fontColor,
            bold: true,
        });
        obj.rend_ativo.forEach((ativo) => {
            rowsTabelaPorClasse.push({
                ativo: ativo.ativo,
                rend: helperFormat(ativo.rend, FormatTypes.monetary, 2, moneyPrefix),
            });
        });
    });
    if (classPeriodData.data.length > 0) {
        rowsTabelaPorClasse.unshift({
            ativo: `Total ${classPeriodData.class}`,
            rend: helperFormat(classPeriodData.value, FormatTypes.monetary, 2, moneyPrefix),
            bgColor: '#444444',
            color: theme.backgroundColor,
            bold: true,
        });
    }
    return rowsTabelaPorClasse;
}
export function formatRowsTabelaRendClasseMesPercent(classPeriodData, dadosPercentPerfPages, theme) {
    const rowsTabelaPorClassePercent = [];
    dadosPercentPerfPages.slice(1).forEach((objs) => {
        if (classPeriodData.class === objs.classe && objs.perf_subclasse) {
            objs.perf_subclasse.forEach((obj) => {
                rowsTabelaPorClassePercent.push({
                    ativo: obj.subclasse,
                    rend: helperFormat(obj.perf, FormatTypes.percentage, 2),
                    bgColor: '#E7E7E7',
                    color: theme.fontColor,
                    bold: true,
                });
                obj.perf_ativo.forEach((ativo) => {
                    rowsTabelaPorClassePercent.push({
                        ativo: ativo.ativo,
                        rend: helperFormat(ativo.perf, FormatTypes.percentage, 2),
                    });
                });
            });
            if (rowsTabelaPorClassePercent.length > 0) {
                rowsTabelaPorClassePercent.unshift({
                    ativo: `Total ${objs.classe}`,
                    rend: helperFormat(objs.perf, FormatTypes.percentage, 2),
                    bgColor: '#444444',
                    color: theme.backgroundColor,
                    bold: true,
                });
            }
        }
    });
    return rowsTabelaPorClassePercent;
}
export function formatBarChartModal(rendimento12meses, periodoModal) {
    const barChartModal = rendimento12meses && periodoModal !== '' && rendimento12meses[periodoModal]
        ? rendimento12meses[periodoModal]
            .slice(1)
            .filter((obj) => obj.rend !== 0 && obj.rend !== '' && obj.rend !== 'nd')
            .map((obj) => {
            return {
                name: obj.classe,
                value: typeof obj.rend === 'number'
                    ? Number(obj.rend.toFixed(2))
                    : Number(Number(obj.rend).toFixed(2)),
                auxTableData: obj.rend_subclasse,
            };
        })
        : null;
    return barChartModal;
}
export function formatBarChartRend12Data(rendimento12meses) {
    const barChartRend12Data = rendimento12meses
        ? Object.keys(rendimento12meses)
            .reverse()
            .map((mes) => {
            const value = rendimento12meses[mes][0].rend;
            return {
                name: mes,
                value: typeof value === 'number'
                    ? Number(value.toFixed(2))
                    : Number(Number(value).toFixed(2)),
            };
        })
        : null;
    return barChartRend12Data;
}
export function formatBarChartModalPercent(dadosPercentPerfPages) {
    const barChartModalPercent = [];
    dadosPercentPerfPages.slice(1).forEach((obj) => {
        barChartModalPercent.push({
            name: obj.classe,
            value: obj.perf,
        });
    });
    return barChartModalPercent;
}
export function formatWaterfallChartModal(preferenceCustomizacao, rendimento12meses, periodoModal, dadosPercentPerfPages, isPercentToggle) {
    let waterfallChartModal = [];
    const waterfallChartModalPercent = [];
    if (!(preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.PerfHist_isBarChart)) {
        let totalPos = -1;
        if (rendimento12meses && periodoModal !== '') {
            let somaRendimento12meses = 0;
            rendimento12meses[periodoModal].map((obj) => {
                somaRendimento12meses +=
                    typeof obj.rend === 'number' ? Number(obj.rend) : Number(Number(obj.rend));
            });
            if (somaRendimento12meses < 0) {
                totalPos = 1;
            }
        }
        let totalPosPercent = -1;
        if (dadosPercentPerfPages && periodoModal !== '') {
            let somaDadosPercentPerfPages = 0;
            dadosPercentPerfPages.map((obj) => {
                somaDadosPercentPerfPages += obj.perf;
            });
            if (somaDadosPercentPerfPages < 0) {
                totalPosPercent = 1;
            }
        }
        let uvIni = 0;
        const totalWaterfall = [];
        waterfallChartModal =
            rendimento12meses && periodoModal !== ''
                ? rendimento12meses[periodoModal]
                    .slice(1)
                    .filter((obj) => obj.rend !== 0 && obj.rend !== '' && obj.rend !== 'nd')
                    .sort((a, b) => typeof a.rend === 'number'
                    ? totalPos * Number(a.rend) - totalPos * Number(b.rend)
                    : totalPos * Number(Number(a.rend)) - totalPos * Number(Number(b.rend)))
                    .map((obj) => {
                    let uvFim = typeof obj.rend === 'number'
                        ? Number(obj.rend.toFixed(2))
                        : Number(Number(obj.rend).toFixed(2));
                    totalWaterfall.push(uvFim);
                    uvFim += uvIni;
                    const uvWaterfall = [uvIni, uvFim];
                    uvIni = uvFim;
                    return {
                        name: obj.classe,
                        value: uvWaterfall,
                        auxTableData: obj.rend_subclasse,
                    };
                })
                : null;
        let uvIniPercent = 0;
        const totalWaterfallPercent = [];
        dadosPercentPerfPages
            .slice(1)
            .sort((a, b) => totalPosPercent * a.perf - totalPosPercent * b.perf)
            .map((obj) => {
            let uvFimPercent = obj.perf;
            totalWaterfallPercent.push(uvFimPercent);
            uvFimPercent += uvIniPercent;
            const uvWaterfall = [uvIniPercent, uvFimPercent];
            uvIniPercent = uvFimPercent;
            waterfallChartModalPercent.push({
                name: obj.classe,
                value: uvWaterfall,
            });
        });
        if ((waterfallChartModal === null || waterfallChartModal === void 0 ? void 0 : waterfallChartModal.length) && (waterfallChartModal === null || waterfallChartModal === void 0 ? void 0 : waterfallChartModal.length) > 1) {
            waterfallChartModal === null || waterfallChartModal === void 0 ? void 0 : waterfallChartModal.push({
                name: 'Total',
                value: [0, totalWaterfall.reduce((a, b) => a + b, 0)],
                auxTableData: [],
            });
            waterfallChartModalPercent === null || waterfallChartModalPercent === void 0 ? void 0 : waterfallChartModalPercent.push({
                name: 'Total',
                value: [0, totalWaterfallPercent.reduce((a, b) => a + b, 0)],
            });
        }
    }
    if (isPercentToggle) {
        return waterfallChartModalPercent;
    }
    else {
        return waterfallChartModal;
    }
}
